/**
 * "Alphameric" means any character 0 - 9, A - Z, a - z, space, and those
 * special characters which have an EBCDIC value greater
 * than hexadecimal "3F" or an ASCII value greater
 * than hexadecimal "1F." Fields defined in these Rules
 * as "alphameric" may contain any of these allowable
 * characters.
 *
 * 0-9: Matches any digit.
 * A-Z: Matches any uppercase letter.
 * a-z: Matches any lowercase letter.
 * \x20-\x7E: Matches any character with an ASCII value from 32 (space) to 126 (tilde ~).
 *   This range covers most printable ASCII characters.
 */
export const ALPHAMERIC_PATTERN = /^([0-9A-Za-z\x20-\x7E]\s?)+$/i;
